module.exports = __webpack_public_path__ + "static/media/loading.d7d01013.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/recorded/loading.png
// module id = 2068
// module chunks = 6